import { defineStore } from 'pinia'

export interface ActionButtonState {
  isStart: boolean,
  touchStart: boolean,
  showJoystick: boolean,
  isShooting: boolean,
  firedWeapon: boolean,
  disabled: boolean
}

const initialState = (): ActionButtonState => ({
  isStart: true,
  touchStart: false,
  showJoystick: false,
  isShooting: false,
  firedWeapon: false,
  disabled: true
})

export const actionButtonState = defineStore('actionButtonState', {
  state: initialState,
})
